(function () {
    angular.module('tmx-app').directive('tmxTreeView', [tmxTreeView]);

    function tmxTreeView() {
        var directive = {
            restrict: 'E'
        };
        directive.controller = ["$scope", "$mdDialog", "$state", "tmxUtility", tmxTreeViewCtrl];
        directive.controllerAs = "tmxTreeViewCtrl";
        directive.scope = {
            value: "=",
            label: "@",
            name: "@",
            gridData: "=",
            disabledNodes: "=",
            form: "=",
            required: "@",
            readonly: "@",
            onChange: '&'
        };
        directive.replace = "true";
        directive.templateUrl = "common/directives/tmxTreeView/tmxTreeView.html";

        return directive;
    }

    function tmxTreeViewCtrl($scope, $mdDialog, $state, tmxUtility) {
        var vm = this;
        vm.scope = $scope;
        var exists = tmxUtility.exists;
        
        function selectItem(id) {
            var index = $scope.gridData.data.findIndex(function(item){return item.LookupId == id})
            $scope.selectedItem = $scope.gridData.data[index];       
        }

        vm.onchange = function (item) {
            if (angular.isFunction($scope.onChange())) {
                $scope.onChange()($scope.value, $scope);
            }
        };

        if (exists($scope.value))
            selectItem($scope.value);

        vm.treeGridDialog = function (ev) {
            if (vm.scope.readonly == "false") {
                $mdDialog.show({
                    locals: { selectedItem: angular.copy($scope.selectedItem), gridData: $scope.gridData, label: $scope.label, disabledNodes: $scope.disabledNodes },
                    controller: ["$scope", "$mdDialog", "$state", 'selectedItem', 'gridData', 'label', 'tmxUtility', 'disabledNodes', DialogController],
                    controllerAs: 'dialogCtrl',
                    template: '<md-dialog ng-cloak flex="80" style="max-width:600px"><form><md-dialog-content style="overflow: overlay !important;"><kendo-treelist id="grid" options="dialogCtrl.mainGridOptions"></kendo-treelist>    </md-dialog-content></form></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                }).then(function (dataItem) {
                    $scope.selectedItem = dataItem;
                    $scope.value = dataItem.LookupId;
                });
            }
        }
    }

    function DialogController($scope, $mdDialog, $state, selectedItem, gridData, label, tmxUtility, disabledNodes) {


        var obj = this;
        obj.mainGridOptions = {
            dataSource: {
                schema: schema
            },
            filterable: true,
        };
        obj.mainGridOptions.dataBound = onDataBound;
        obj.mainGridOptions.dataSource.data = gridData;
        obj.mainGridOptions.selectable = true;
        obj.mainGridOptions.preventDefault = true;
        obj.mainGridOptions.columns = [];
        var applyClassOnRows = tmxUtility.applyClassOnRows;
        var findItems = tmxUtility.findItems;
        var exists = tmxUtility.exists;
        obj.disabledItems = [];
        obj.mainGridOptions.columns = [{
            field: "VisibleValue",
            title: label,
            template: "\{\{ dataItem.VisibleValue \}\}"
        }
        ]

        obj.mainGridOptions.change = function (e) {
            var selectedRows = this.select();
            var item = this.dataItem(selectedRows[0]);
            if (obj.disabledItems.length <= 0)// if no readonly selection then just return the clicked item
                $scope.hide(item);
            else if (obj.disabledItems.length > 0) {//otherwise, only if there are some readonly items then see if current item is one of readonly items
                var isDisabled = findItems("LookupId", item.LookupId, obj.disabledItems).length > 0;
                if (isDisabled) {//if yes then unselect it and select the previous deselected item
                    applyClassOnRows(e.sender, "LookupId", item.LookupId, "k-state-selected k-state-selecting", true);
                    if (exists(selectedItem))
                        applyClassOnRows(e.sender, "LookupId", selectedItem.LookupId, "k-state-selected k-state-selecting");
                }
                else {//else it  means item is valid to return so don't hesitate
                    $scope.hide(item);
                }
            }
        }
        $scope.hide = function (item) {
            $mdDialog.hide(item);
        }
        function onDataBound(arg) {

            if (exists(selectedItem)) {
                expandItem(arg.sender, selectedItem);
                applyClassOnRows(arg.sender, "LookupId", selectedItem.LookupId, "k-state-selected k-state-selecting");
            }
        }
        function expandItem(kendoTree, item) {
            if (!exists(item.ParentLookupId) || item.ParentLookupId == null) {
                return;
            }
            var items = kendoTree.dataItems();
            var parent = findItems("LookupId", item.ParentLookupId, items)[0];
            expandItem(kendoTree, parent);
            var parentRow = kendoTree.element.find("tr[data-uid=" + parent.uid + "]");
            kendoTree.expand(parentRow);
        }     
    }
    var schema = {
        data: "data",
        total: "Total",
        model: {
            id: "LookupId",
            parentId: "ParentLookupId",
            fields: {
                LookupId: {
                    type: "number",
                    editable: false,
                    nullable: false
                },
                ParentLookupId: {
                    nullable: true,
                    type: "number"
                }
            }
        }
    }

})();